import { render, staticRenderFns } from "./PeriodRead.vue?vue&type=template&id=6791a186&scoped=true"
import script from "./PeriodRead.vue?vue&type=script&lang=js"
export * from "./PeriodRead.vue?vue&type=script&lang=js"
import style0 from "./PeriodRead.vue?vue&type=style&index=0&id=6791a186&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6791a186",
  null
  
)

export default component.exports